//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import Table from '~/views/MerchantsFees/Fees/Table.vue';

export default {
  components: {
    Table,
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.load(),
      this.loadProviders(),
      this.loadCurrencies(),
    ]);
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    ...mapActions('merchantsFees', {
      load: 'loadData',
      loadProviders: 'loadProviders',
      loadCurrencies: 'loadCurrencies',
    }),
  },
};
